export default {
    props: {
        seriesDefaultsArea: {
            type: Object,
            default: undefined,
            kComposite: 'seriesDefaults.area'
        }, 
        seriesDefaultsBar: {
            type: Object,
            default: undefined,
            kComposite: 'seriesDefaults.bar'
        }, 
        seriesDefaultsBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.border.color'
        }, 
        seriesDefaultsBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.border.dashType'
        }, 
        seriesDefaultsBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.border.width'
        }, 
        seriesDefaultsColumn: {
            type: Object,
            default: undefined,
            kComposite: 'seriesDefaults.column'
        }, 
        seriesDefaultsGap: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.gap'
        }, 
        seriesDefaultsLabelsBackground: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.labels.background'
        }, 
        seriesDefaultsLabelsBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.labels.border.color'
        }, 
        seriesDefaultsLabelsBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.labels.border.dashType'
        }, 
        seriesDefaultsLabelsBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.border.width'
        }, 
        seriesDefaultsLabelsColor: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.labels.color'
        }, 
        seriesDefaultsLabelsFont: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.labels.font'
        }, 
        seriesDefaultsLabelsFormat: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.labels.format'
        }, 
        seriesDefaultsLabelsMargin: {
            type: [Number, Object],
            default: undefined,
            kComposite: 'seriesDefaults.labels.margin'
        }, 
        seriesDefaultsLabelsPadding: {
            type: [Number, Object],
            default: undefined,
            kComposite: 'seriesDefaults.labels.padding'
        }, 
        seriesDefaultsLabelsTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'seriesDefaults.labels.template'
        }, 
        seriesDefaultsLabelsVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'seriesDefaults.labels.visible'
        }, 
        seriesDefaultsLine: {
            type: Object,
            default: undefined,
            kComposite: 'seriesDefaults.line'
        }, 
        seriesDefaultsOverlay: {
            type: Object,
            default: undefined,
            kComposite: 'seriesDefaults.overlay'
        }, 
        seriesDefaultsPie: {
            type: Object,
            default: undefined,
            kComposite: 'seriesDefaults.pie'
        }, 
        seriesDefaultsSpacing: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.spacing'
        }, 
        seriesDefaultsStack: {
            type: Boolean,
            default: undefined,
            kComposite: 'seriesDefaults.stack'
        }, 
        seriesDefaultsStackType: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.stack.type'
        }, 
        seriesDefaultsType: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.type'
        }, 
        seriesDefaultsTooltipBackground: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.tooltip.background'
        }, 
        seriesDefaultsTooltipBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.tooltip.border.color'
        }, 
        seriesDefaultsTooltipBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.tooltip.border.width'
        }, 
        seriesDefaultsTooltipColor: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.tooltip.color'
        }, 
        seriesDefaultsTooltipFont: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.tooltip.font'
        }, 
        seriesDefaultsTooltipFormat: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.tooltip.format'
        }, 
        seriesDefaultsTooltipPadding: {
            type: [Number, Object],
            default: undefined,
            kComposite: 'seriesDefaults.tooltip.padding'
        }, 
        seriesDefaultsTooltipTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'seriesDefaults.tooltip.template'
        }, 
        seriesDefaultsTooltipVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'seriesDefaults.tooltip.visible'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoSparkline/SeriesDefaults.js